import PointUsers from '@/component/point/point-list/UserList';

export default function PointUserList() {
  return (
    <>
      <PointUsers />
    </>
  );
}
